import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { LoadingIndicator as CanaveralLoadingIndicator } from '@storable/canaveral-components';
import styles from './styles.scss';

const propTypes = {
  className: PropTypes.string,
};

const defaultProps = {
  className: undefined,
};

const LoadingIndicator = ({ className }) => {
  const classes = cx(
    styles.loadingIndicator,
    className,
  );

  return (
    <CanaveralLoadingIndicator
      className={classes}
    />
  );
};

LoadingIndicator.propTypes = propTypes;
LoadingIndicator.defaultProps = defaultProps;

export default LoadingIndicator;
